var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('page-section', {
    staticClass: "page-section--first"
  }, [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg text-center"
  }, [_vm._v(" 리본바이옴은 "), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("20년 전통의 건강기능식품 전문제조브랜드")]), _vm._v("로, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 파트너 여러분께 안정적인 수익 기회와 성장 지원을 제공합니다. ")])]), _c('v-row', _vm._l(_vm.items, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "lg": "3"
      }
    }, [_c('v-card', {
      staticClass: "partner-card",
      attrs: {
        "rounded": "xl"
      }
    }, [_c('div', [_c('v-card-title', {
      staticClass: "justify-center"
    }, [_c('h3', {
      staticClass: "tit tit--xs primary--text text--darken-1"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])]), _c('v-card-text', {
      staticClass: "text-center pt-2"
    }, [_c('p', {
      staticClass: "txt grey--text text--darken-4 font-weight-medium",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])], 1)])], 1);
  }), 1), _c('div', {
    staticClass: "btn-wrap btn-wrap--lg d-flex justify-center"
  }, [_c('v-btn', {
    staticClass: "v-size--xx-large",
    attrs: {
      "to": "/join",
      "color": "primary"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("파트너 등록하기")]), _c('v-img', {
    staticClass: "ml-10px",
    attrs: {
      "src": "/images/icon/icon-arrow-right.svg",
      "alt": ""
    }
  })], 1)], 1)], 1), _c('page-section', {
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("파트너 등록 "), _c('span', {
          staticClass: "primary--text"
        }, [_vm._v("자격 및 조건")])];
      },
      proxy: true
    }, {
      key: "txt",
      fn: function () {
        return [_vm._v("가입하기 전 파트너 등록 자격 요건이나 사전 준비사항을 미리 확인하세요!")];
      },
      proxy: true
    }])
  }, [_c('v-row', {
    staticClass: "row--sm"
  }, _vm._l(_vm.questions, function (question, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "lg": "6"
      }
    }, [_c('v-card', {
      staticClass: "pa-6 pa-lg-10",
      attrs: {
        "color": "grey lighten-5",
        "rounded": "lg",
        "height": "100%"
      }
    }, [_c('v-row', {
      staticClass: "row--sm"
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "tit tit--xs"
    }, [_c('v-row', {
      staticClass: "row--sm"
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_vm._v("Q")]), _c('v-col', [_vm._v(_vm._s(question.q))])], 1)], 1)]), _c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "txt txt--lg"
    }, [_c('v-row', {
      staticClass: "row--sm"
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v("A")])]), _c('v-col', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(question.a)
      }
    })])], 1)], 1)])], 1)], 1)], 1);
  }), 1)], 1), _c('page-section', {
    staticClass: "page-section--last pt-0",
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("파트너 "), _c('span', {
          staticClass: "primary--text"
        }, [_vm._v("가입 절차")])];
      },
      proxy: true
    }, {
      key: "txt",
      fn: function () {
        return [_vm._v("가입하기 전 파트너 등록 자격 요건이나 사전 준비사항을 미리 확인하세요!")];
      },
      proxy: true
    }])
  }, [_c('v-row', {
    staticClass: "row--xxl",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('membership-steps')], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "v-size--xx-large",
    attrs: {
      "to": "/join",
      "color": "primary"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("파트너 등록하기")]), _c('v-img', {
    staticClass: "ml-10px",
    attrs: {
      "src": "/images/icon/icon-arrow-right.svg",
      "alt": ""
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "px-20px py-30px pa-lg-60px",
    attrs: {
      "img": "/images/partner/banner.jpg",
      "rounded": "xl"
    }
  }, [_c('v-row', {
    staticClass: "row--lg",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('div', {
    staticClass: "tit white--text"
  }, [_c('div', {
    staticClass: "tit--xs"
  }, [_vm._v("추가로 궁금한 점이 있으신가요?")]), _c('div', {
    staticClass: "tit--sm"
  }, [_vm._v("온라인 상담채널로 문의주세요.")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "to": "/mypage/questions",
      "color": "white",
      "min-width": "160px",
      "rounded": "10",
      "x-large": ""
    }
  }, [_vm._v("문의하기")])], 1)], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }